import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import classnames from 'classnames';
import throttle from 'lodash/throttle';

import QrScanner from 'src/components/QrScanner';
import Button from 'src/components/Button';

import { ROUTE_TYPES_VALUES } from 'src/modules/Restaurant';

import theme from 'src/styles/components/QrCodeButton.module.scss';
import { useIntl } from 'react-intl';

const QrCodeButton = ({
    emitMessage,
    className,
    size,
    flat,
    context,
    canCreateOrders,
    sessionError
}) => {
    const intl = useIntl();

    const showQrScanner = useCallback(throttle(() => {
        emitMessage({
            title: intl.formatMessage({ id: 'App.qrCodeScanning' }),
            message: (
                <QrScanner />
            ),
            type: 'small',
            className: theme.modal,
            isDismissButtonEnabled: true,
            isBackdropClickEnabled: false
        });
    }, 2000), []);

    if (!(!context
        || context.routeType === ROUTE_TYPES_VALUES.BILL_WAIT
        || context.routeType === ROUTE_TYPES_VALUES.MENU
        || context.routeType === ROUTE_TYPES_VALUES.RESTAURANT_CLOSED
        || context.routeType === ROUTE_TYPES_VALUES.AREA_NOT_ACTIVE
        || !canCreateOrders
        || sessionError)) {
        return null;
    }

    return (
        <Button
          className={classnames(className, theme.button, { [theme.large]: size === 'lg' })}
          aria-label="qr scanner"
          icon="icon-scan"
          onClick={showQrScanner}
          floating
          mini
          flat={flat}
        />
    );
};

QrCodeButton.propTypes = {
    emitMessage: PropTypes.func.isRequired,
    className: PropTypes.string,
    size: PropTypes.string,
    context: PropTypes.shape({
        restaurantId: PropTypes.string,
        tableId: PropTypes.string,
        routeType: PropTypes.number
    }),
    canCreateOrders: PropTypes.bool,
    sessionError: PropTypes.bool,
    flat: PropTypes.bool
};

QrCodeButton.defaultProps = {
    size: 'lg',
    flat: false
};

export default QrCodeButton;
